import { PageHeaderControl } from "@seims/shared";
import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Notify } from "../../services/custom/Messages";
import eventsService from "../../services/eventsService";
import { openNotification } from "../custom";
import { DataCapturerCard } from "./DataCapturerCard";

export const AddDataCapturerToEvent = () => {
  const { id } = useParams();
  const [admins, setAdmins] = useState([]);
  const hasInitialized = useRef(false);
  const location = useLocation();
    
  
    const {eventName} = location.state || {};

  const getExistingAdmins = async () => {
    try {
      const response = await eventsService.getAdministratorsForEvent(id);
      console.log(response);
      
      if (response?.data) {
        setAdmins(response.data.results || []);
      } else if (response?.status === 204) {
        openNotification(
          "Event Data Capturers",
          "No existing data capturers.",
          Notify.INFO,
        );
      } else {
        openNotification(
          "Event Data Capturers",
          "Failed to load existing data capturers.",
          Notify.WARNING,
        );
      }
    } catch (error) {
      console.error("Error fetching existing admins:", error);
      openNotification(
        "Event Data Capturers",
        "An error occurred while fetching existing data capturers. Please try again.",
        Notify.ERROR,
      );
    }
  };

  useEffect(() => {
    if (!hasInitialized.current && id) {
      getExistingAdmins();
      hasInitialized.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // ------------------------------------------------------------------
  // NEW: The Backend Save Handler
  // ------------------------------------------------------------------
  const handleSaveAdminBE = async (adminData, editIndex) => {
    try {
      // Your service expects (eventId, admins). 
      // We wrap the single new admin in an array to match the expected payload.
      const payload = [adminData]; 
      
      await eventsService.createAdministratorsForEvent(id, payload);
      
      openNotification(
        "Event Data Capturers", 
        editIndex !== null ? "Data capturer updated successfully" : "Data capturer added successfully", 
        Notify.SUCCESS
      );

      await getExistingAdmins();
    } catch (error) {
      console.error("Failed to save data capturer to backend:", error);
      openNotification(
        "Event Data Capturers", 
        "Failed to save Data Capturer to the server. Please try again.", 
        Notify.ERROR
      );
      
      // CRITICAL: We throw the error here so the AdminCapture component 
      // catches it, stops the loading spinner, and keeps the form open!
      throw error; 
    }
  };
  return (
    <div style={{ padding: '24px', margin: '0 auto' }}>
      <PageHeaderControl title={eventName ?? `Event Data Capturers`} >
        <DataCapturerCard 
          existingAdmins={admins} 
          exportAdmins={setAdmins} 
          // 1. Turn on the live-save mode
          allowedToSave={true} 
          // 2. Pass the async function down
          onSaveAdminBE={handleSaveAdminBE} 
        />
      </PageHeaderControl>
      
    </div>
  );
};